export default __webpack_public_path__ + "static/SRUS P212 - Especification Del Producto y Datos Técnicos-c694ec337a7334ab769abc1d3c3f0cc2.pdf";